import { getUrlApi } from "../utilities/util";
import ApiHandler from "./ApiHandlers/ApiHandler";

export const baseURL = String(getUrlApi());

export default class ProductionUnitApi {
  /**
   * @deprecated Use GetProductionUnitsFilter instead for better performance with server-side pagination.
   */
  static async GetAllProductUnit(): Promise<any> {
    return ApiHandler(baseURL).get("/v1/production-units/all");
  }

  static async GetProductionUnitsFilter(params: any): Promise<any> {
    return ApiHandler(baseURL).get("/v1/production-units/filter", { params });
  }

  static async GetProductUnitById(id: string): Promise<any> {
    return ApiHandler(baseURL).get("/v1/production-units/" + id);
  }

  static async GetProductUnitByPlant(plantId: string): Promise<any> {
    return ApiHandler(baseURL).get(`/v1/production-units/plant/${plantId}`);
  }

  static async CreateProductUnit(plantId: string, name: string): Promise<any> {
    return ApiHandler(baseURL).post("/v1/production-units", {
      plantId,
      name,
    });
  }

  static async UpdateProductUnit(
    id: string,
    plantId: string,
    name: string,
  ): Promise<any> {
    return ApiHandler(baseURL).put(`/v1/production-units/${id}`, {
      plantId,
      name,
    });
  }

  static async DeleteProductUnit(id: string): Promise<any> {
    return ApiHandler(baseURL).delete(`/v1/production-units/${id}`);
  }
}
